import React, { Component } from 'react';
import { Table, Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { toastr } from 'react-redux-toastr';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import gql from 'graphql-tag';
import s from './ManageNotificationsForm.css';
import CustomPagination from '../../CustomPagination';
import adminGetScheduledNotificationQuery from '../../../routes/site-admin/manageNotifications/adminGetScheduledNotification.graphql';

const USER_TYPE_LABEL = {
  1: 'Customer',
  2: 'Driver',
  3: 'Shop',
  null: 'All',
  undefined: 'All',
};

const STATUS_BADGE = {
  pending: { label: 'Pending', cls: 'badge bg-warning text-dark' },
  sent: { label: 'Sent', cls: 'badge bg-success' },
  failed: { label: 'Failed', cls: 'badge bg-danger' },
};

class ScheduledNotificationTable extends Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 1 };
    this.handleDelete = this.handleDelete.bind(this);
    this.paginationData = this.paginationData.bind(this);
  }

  async handleDelete(id) {
    if (!window.confirm('Delete this scheduled notification?')) return;
    try {
      const res = await fetch('/graphql', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: `mutation deleteScheduledNotification($id: Int) {
            deleteScheduledNotification(id: $id) { status errorMessage }
          }`,
          variables: { id },
        }),
        credentials: 'include',
      });
      const { data } = await res.json();
      if (data?.deleteScheduledNotification?.status === 200) {
        toastr.success('Deleted', 'Scheduled notification deleted.');
        this.props.adminGetScheduledNotification.refetch({ currentPage: this.state.currentPage });
      } else {
        toastr.error('Error', data?.deleteScheduledNotification?.errorMessage || 'Failed to delete.');
      }
    } catch (e) {
      toastr.error('Error', 'Failed to delete.');
    }
  }

  paginationData(page) {
    this.setState({ currentPage: page });
    this.props.adminGetScheduledNotification.refetch({ currentPage: page });
  }

  render() {
    const { adminGetScheduledNotification: { loading, adminGetScheduledNotification: data }, onEdit } = this.props;
    const { currentPage } = this.state;

    const rows = data && data.results || [];
    const count = data && data.count || 0;

    return (
      <div className={s.tableSection}>
        <div className={cx(s.sectionHeading, 'mb-3')}>Scheduled Notifications</div>
        {loading ? (
          <p className="text-muted">Loading...</p>
        ) : (
          <>
            <div className={cx('tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
              <Table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Body</th>
                    <th>Scheduled At</th>
                    <th>Target</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={7} className={s.noRecords}>No scheduled notifications.</td>
                    </tr>
                  )}
                  {rows.map((item) => {
                    const badge = STATUS_BADGE[item.status] || STATUS_BADGE.pending;
                    const localTime = item.scheduledAt
                      ? new Intl.DateTimeFormat('en-GB', {
                          day: '2-digit', month: 'short', year: 'numeric',
                          hour: '2-digit', minute: '2-digit',
                          timeZone: item.timezone || 'UTC',
                          timeZoneName: 'short',
                        }).format(new Date(item.scheduledAt))
                      : '-';
                    return (
                      <tr key={item.id}>
                        <td data-label="#">{item.id}</td>
                        <td data-label="Title">{item.title}</td>
                        <td data-label="Body">
                          <span title={item.body}>
                            {item.body.length > 60 ? `${item.body.slice(0, 60)}…` : item.body}
                          </span>
                        </td>
                        <td data-label="Scheduled At" style={{ whiteSpace: 'nowrap' }}>{localTime}</td>
                        <td data-label="Target">{USER_TYPE_LABEL[item.userType]}</td>
                        <td data-label="Status">
                          <span className={badge.cls}>{badge.label}</span>
                        </td>
                        <td data-label="Actions" className={s.actionCell}>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="me-2"
                            onClick={() => onEdit && onEdit(item)}
                          >
                            Edit
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => this.handleDelete(item.id)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            {count > 10 && (
              <div className={cx(s.space5, s.spaceTop5)}>
                <CustomPagination
                  total={count}
                  currentPage={currentPage}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  change={this.paginationData}
                  paginationLabel="scheduled notifications"
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(adminGetScheduledNotificationQuery, {
    name: 'adminGetScheduledNotification',
    options: {
      variables: { currentPage: 1 },
      fetchPolicy: 'network-only',
    },
  }),
)(ScheduledNotificationTable);
